<style lang="less" scoped>
@import url('../../../style/common/variable.less');
@media screen and (min-width: @max-screen)
{
  ul {width: 1200px;}
  li {margin-right: 21px;}
  .input {width: 166px !important;}
}
@media screen and (max-width: @max-screen)
{
  ul {width: 100%;padding: 0;}
  li {margin: 2%;}
  .input {width: 130px !important;}
}
.searchBarKYXM {position: relative;
ul {display: flex;list-style: none;}
li {float: left;font-size: 14px;}
.input {font-family: MicrosoftYaHei;font-size: 14px !important;;}
.el-select {width: 166px !important;font-family: MicrosoftYaHei;}
.button {width: 40px !important;height: 40px !important;font-size: 24px;background-color: white;border: solid rgb(219, 216, 216);border-width: 1px;border-radius: 5px;cursor: pointer;}}
.button:active{color:#13569e;}
</style>

<template>
  <div class="searchBarKYXM">
    <ul>
      <li>
        <el-select v-model="LeiBie" placeholder="项目类别" :clearable="true">
          <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </li>
      <li v-if="ifShowFlag">
        <el-select v-model="ZhongLei" placeholder="矿产种类" :clearable="true">
          <el-option v-for="item in options2" :key="item.id" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </li>
      <li v-if="ifShowFlag">
        <el-select v-model="HeZuo" placeholder="合作方式" :clearable="true">
          <el-option v-for="item in options3" :key="item.id" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </li>
      <li v-if="ifShowFlag">
        <el-select v-model="GuoJia" placeholder="国家" :clearable="true">
          <el-option v-for="item in options4" :key="item.id" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </li>
      <li>
        <el-input class="input" v-model="Input" placeholder="请输入关键词"></el-input>
      </li>
      <li>
        <button class="button" @click="searchdata([LeiBie, ZhongLei, HeZuo, GuoJia, Input])"><i class="el-icon-search"></i></button>
      </li>
    </ul>
  </div>
</template>

<script>
/**
 * 何宽 2021.7.6
 * 搜索栏：四个select框、一个input框、一个搜索按钮，根据设置的条件搜索数据
 */
export default {
  data()
  {
    return {
      options1: [
        { id: '选项1', name: '采矿权',   value: '1' },
        { id: '选项2', name: '探矿权',   value: '2' },
        { id: '选项3', name: '深加工',   value: '3' },
        { id: '选项4', name: '其它',     value: '4' }
      ],
      LeiBie: '',
      options2: [
        { id: '选项1', name: '稀贵金属', value: '稀贵金属' },
        { id: '选项2', name: '有色金属', value: '有色金属' },
        { id: '选项3', name: '黑色金属', value: '黑色金属' },
        { id: '选项4', name: '非金属',   value: '非金属' },
        { id: '选项5', name: '其它',     value: '其它' }
      ],
      ZhongLei: '',
      options3: [
        { id: '选项1', name: '合作',      value: '合作' },
        { id: '选项2', name: '转让',      value: '转让' },
        { id: '选项3', name: '合作,转让', value: '合作,转让' }
      ],
      HeZuo: '',
      options4: [
        { id: '选项1',  name: '中国',      value: 2 },
        { id: '选项2',  name: '印度尼西亚', value: 3 },
        { id: '选项3',  name: '马来西亚',   value: 4 },
        { id: '选项4',  name: '菲律宾',     value: 5 },
        { id: '选项5',  name: '新加坡',     value: 6 },
        { id: '选项6',  name: '泰国',       value: 7 },
        { id: '选项7',  name: '文莱',       value: 8 },
        { id: '选项8',  name: '越南',       value: 9 },
        { id: '选项9', name: '老挝',       value: 10 },
        { id: '选项10', name: '缅甸',       value: 11 },
        { id: '选项11', name: '柬埔寨',     value: 12 },
        { id: '选项12', name: '其他',       value: 13 }
      ],
      GuoJia: '',
      Input: '',
      ifShowFlag: true
    }
  },

  
  mounted()
  {
    if (window.innerWidth > 912)
      this.ifShowFlag = true
    else
      this.ifShowFlag = false
  },

  methods: {
    searchdata(arr)
    {
      this.$emit('searchdata', arr)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/SearchBarKYXM.vue